import type { IconData } from '@stacksjs/iconify-core'

export const batteryThreeQuartersF: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M13 2v8h4V2zm6 1a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h15a2 2 0 0 1 2 2z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default batteryThreeQuartersF
